import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import _ from "lodash";
import Button from "../components/Button";

const ContainerButtonGroup = styled.div`
  display: flex;
  ${({ direction }) => {
    if (direction === 'horizontal') {
      return `
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
      `;
    } else {
      return `
        flex-direction: column;
      `;
    }
  }}
  button {
    margin-bottom: 10px;
  }
`;

class ButtonGroup extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape()),
    type: PropTypes.string,
    direction: PropTypes.string
  };
  static defaultProps = {
    value: "item2",
    items: [
      { value: "item1", label: "Item 1" },
      { value: "item2", label: "Item 2" },
      { value: "item3", label: "Item 3" }
    ],
    direction: "horizontal",
    renderItem: ({ value, label, active, type, key, onClick }) => {
      return (
        <Button
          key={key}
          type="primary"
          active={active}
          activeStyle={{ backgroundColor: "#ffffff", color: "black" }}
          hoverStyle={{ backgroundColor: "#ffffff", color: "black" }}
          defaultStyle={{ marginRight: "3px", backgroundColor: "#dbdbdb" }}
          onClick={onClick}
        >
          {label} {active ? "active" : ""}
        </Button>
      );
    }
  };

  render() {
    const { items, direction } = this.props;
    return (
      <ContainerButtonGroup direction={direction}>
        {_.map(items, (item, key) => {
          return this.props.renderItem({
            ...item,
            key,
            active: this.props.value === item.value,
            onClick: () => {
              this.props.onChange(item.value)
            },
          });
        })}
      </ContainerButtonGroup>
    );
  }
}

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/ButtonGroup.js